import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { auth as authAPI } from '../services/api';
import '../styles/Auth.css';

const Register = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [registeredEmail, setRegisteredEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const [showResend, setShowResend] = useState(false);

  const { register } = useAuth();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (formData.password !== formData.confirmPassword) {
      setError('A jelszavak nem egyeznek');
      return;
    }

    if (formData.password.length < 6) {
      setError('A jelszónak legalább 6 karakter hosszúnak kell lennie');
      return;
    }

    setLoading(true);

    try {
      const result = await register(formData.name, formData.email, formData.password);

      // Email verification required
      if (result.requiresVerification) {
        setSuccess(result.message);
        setRegisteredEmail(formData.email);
        setShowResend(true);
        // Clear form
        setFormData({
          name: '',
          email: '',
          password: '',
          confirmPassword: ''
        });
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Hiba történt a regisztráció során');
    } finally {
      setLoading(false);
    }
  };

  const handleResendEmail = async () => {
    setResending(true);
    setError('');
    setSuccess('');

    try {
      const response = await authAPI.resendVerification(registeredEmail);
      setSuccess(response.data.message || 'Email újraküldve!');
    } catch (err) {
      setError(err.response?.data?.message || 'Email küldése sikertelen');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="container">
        <div className="auth-card card">
          <h2>Regisztráció</h2>

          {/* Success Message - Email Verification Needed */}
          {success && (
            <div className="success-box">
              <div className="success-icon">✨</div>
              <h3>Regisztráció sikeres!</h3>
              <p className="success-message">{success}</p>
              <div className="email-highlight">
                <strong>{registeredEmail}</strong>
              </div>
              <p className="verification-note">
                Kattints az emailben található linkre a megerősítéshez. Az email 24 órán keresztül érvényes.
              </p>

              {showResend && (
                <div className="resend-container">
                  <p className="resend-question">Nem kaptad meg az emailt?</p>
                  <button
                    className="btn btn-outline"
                    onClick={handleResendEmail}
                    disabled={resending}
                  >
                    {resending ? 'Küldés...' : 'Email Újraküldése'}
                  </button>
                </div>
              )}

              <Link to="/login" className="btn btn-primary" style={{ marginTop: '1.5rem' }}>
                Tovább a Bejelentkezéshez
              </Link>
            </div>
          )}

          {/* Registration Form */}
          {!success && (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Teljes név</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email cím</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Jelszó</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  minLength="6"
                />
              </div>

              <div className="form-group">
                <label htmlFor="confirmPassword">Jelszó megerősítése</label>
                <input
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  required
                  minLength="6"
                />
              </div>

              {error && <div className="error-message">{error}</div>}

              <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
                {loading ? 'Regisztráció...' : 'Regisztráció'}
              </button>
            </form>
          )}

          {!success && (
            <p className="auth-link">
              Már van fiókod? <Link to="/login">Jelentkezz be itt!</Link>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Register;
